import { SyntheticEvent } from 'react';
import classnames from 'classnames';
import Button from '@mui/material/Button';

import { styles } from './styles';

interface GenericActionButtonProps {
  className?: string;
  label?: string;
  isLoading?: boolean;
  onClick?: (e: SyntheticEvent<any>) => void;
  type?: "button" | "submit" | "reset";
  startIcon?: JSX.Element;
  testId?: string;
  href?: string;
}

const GenericActionButton = ({ label, isLoading = false, onClick, className, type = "submit", startIcon, testId, href = null }: GenericActionButtonProps) => {
  const { classes } = styles();
  return (
    <Button
      onClick={onClick}
      disabled={!!isLoading}
      className={classnames(classes.button, { [classes.isButtonLoading]: !!isLoading }, className)}
      type={type}
      startIcon={startIcon}
      href={href}
      data-testid={testId ?? 'generic-button'}>
        {label || 'Guardar'}
      </Button>
  );
};

export default GenericActionButton;
